<template>
  <div id="app">
    <div v-if="showIndex">
      <router-view></router-view>
    </div>
    <div v-else-if="showLoad">
      <div class="none">网站建设中。。。</div>
    </div>

  </div>

</template>

<script type="es6">
  import {mapGetters} from "vuex";
  import {logoutTime, sensitiveWords, siteSwitch} from "./config/axioUtilUcas";
  import cookie from "../static/js/cookie";
  // import HeaderView from "./components/header";
  // import FooterView from "./components/footer";
export default {
  name: 'App',
  data(){
    return {
      showHead: true,
      showLoad: false,
      showIndex: false,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    })
  },
  created() {
    this.route = window.location.href
  },
  mounted() {
    this.showOrHidden()
    this.onScroll()
    this.timerInterval()
    this.getSensitiveWords()
    this.getSiteSwitch()

  },
  methods: {
    showOrHidden(){
      if (this.route.indexOf('moreCity')>-1){
        this.showHead = false
      }else {
        this.showHead = true
      }
    },
    timerInterval(){
      let that = this
      if(!this.userInfo.username) return;
      let i=0
      let timer = setInterval(()=>{
        i++
        function changeTime(){
          let lastTime = localStorage.getItem('lastPost') || null
          let nowTime = Date.now()
          if (!lastTime){
            localStorage.setItem('lastPost', nowTime)
            lastTime = nowTime
          }
          let logOutTime = localStorage.getItem('logout-time') || 30
          if(nowTime - Number(lastTime)>= (Number(logOutTime)*60*1000)){
            if (cookie.getCookie('username')){
              //  退出
              clearInterval(timer)
              cookie.delCookie('token');
              cookie.delCookie('name');
              cookie.delCookie('username');
              //更新store数据
              that.$store.dispatch('setInfo');
              that.$emit('getAlternative', 0)
              that.$message({
                message: '登录超时',
                type: 'info'
              });
              that.$router.push({name: 'index'})
            }
          }
        }
        changeTime()
      }, 1000*60)
    },
    onScroll(){
      let that = this
      logoutTime({name: '优卡思教育'}).then(data=>{
        if(data.data[0]){
          localStorage.setItem('logout-time', data.data[0].time)
        }else {
          localStorage.setItem('logout-time', 30)
        }
      }).catch(err=> console.log(err))
      window.addEventListener('scroll', function (){
        changeTime()
      })
      document.addEventListener('keyup', function (){
        changeTime()
      })
      document.addEventListener('mouseup', function (){
        changeTime()
      })
      document.addEventListener('mousemove', function (){
        changeTime()
      })
      // window.onscroll = function (){
      //   changeTime()
      // }
      // document.onkeyup = function (){
      //   changeTime()
      // }
      // document.onmouseup = function (){
      //   changeTime()
      // }
      // document.onmousemove = function (){
      //   changeTime()
      // }
      function changeTime(){
        let lastTime = localStorage.getItem('lastPost') || null
        let nowTime = Date.now()
        if (!lastTime){
          localStorage.setItem('lastPost', nowTime)
          lastTime = nowTime
        }
        let logOutTime = localStorage.getItem('logout-time') || 30
        if(nowTime - Number(lastTime)>= (Number(logOutTime)*60*1000)){
          if (cookie.getCookie('username')){
            //  退出
            cookie.delCookie('token');
            cookie.delCookie('name');
            cookie.delCookie('username');
            //更新store数据
            that.$store.dispatch('setInfo');
            that.$emit('getAlternative', 0)
            console.log(111)
            that.$message({
              message: '登录超时',
              type: 'info'
            });
            that.$router.push({name: 'index'})
          }
        }else {
          localStorage.setItem('lastPost', nowTime)
        }
      }
    },
    getSensitiveWords(){
      sensitiveWords().then(data=>{
        sessionStorage.setItem('keywords', JSON.stringify(data.data))
        // let a = checkSensitiveWord('发售B样a片')
      }).catch(err=>{

      })

    },
    getSiteSwitch(){
      siteSwitch().then(data=>{
        console.log(data)
        if(data.data.length===0 || !data.data[0].switch && this.$route.name === 'index'){
          this.showLoad = true
        } else {
          this.showIndex = true
        }
      }).catch(err=>{
        this.showLoad = true
      })
    },
  },
  // components:{
  //   FooterView,
  //   HeaderView,
  // },

}
</script>

<style>
  @import "../static/plugin/pluginBox.css";
#app {
  font-family: "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei UI","Microsoft YaHei",SimHei,"宋体",simsun,sans-serif;
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  font-size: 14px;
  background-color: white;
  /*margin-top: 60px;*/
}
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  cursor: pointer;
  user-select: none;
}
  input, textarea {
    -webkit-user-select: text;
    line-height: normal!important;
  }
  .none {
    left: 50%;
    position: absolute;
    top: 30%;
    font-size: xx-large;
    transform: translate(-50%, 0);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue